/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_nav_budget_builder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budget Builder`)
};

const es_f1_nav_budget_builder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budget Builder`)
};

const de_f1_nav_budget_builder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budget Builder`)
};

const nl_f1_nav_budget_builder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budget Builder`)
};

const fr_f1_nav_budget_builder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budget Builder`)
};

const it_f1_nav_budget_builder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budget Builder`)
};

const pt_br2_f1_nav_budget_builder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budget Builder`)
};

const pt_f1_nav_budget_builder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Budget Builder`)
};

const ja_f1_nav_budget_builder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`バジェットビルダー`)
};

const zh_f1_nav_budget_builder = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预算构建器`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_nav_budget_builder = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_nav_budget_builder(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_nav_budget_builder", locale)
	if (locale === "en") return en_f1_nav_budget_builder(inputs)
	if (locale === "es") return es_f1_nav_budget_builder(inputs)
	if (locale === "de") return de_f1_nav_budget_builder(inputs)
	if (locale === "nl") return nl_f1_nav_budget_builder(inputs)
	if (locale === "fr") return fr_f1_nav_budget_builder(inputs)
	if (locale === "it") return it_f1_nav_budget_builder(inputs)
	if (locale === "pt-BR") return pt_br2_f1_nav_budget_builder(inputs)
	if (locale === "pt") return pt_f1_nav_budget_builder(inputs)
	if (locale === "ja") return ja_f1_nav_budget_builder(inputs)
	return zh_f1_nav_budget_builder(inputs)
};